<template>
  <div id="app">
    <b-toast
      id="example-toast"
      title="Message"
      :variant="alert.type"
      v-show="alert.message"
      toaster="b-toaster-bottom-full"
      auto-hide-delay="5000"
    >
      {{ alert.message }}
    </b-toast>

    <div class="containerBackground" :style="{ minHeight: hauteur }">
      <header
        style="
          width: 100%;
          z-index: 1000;
          background: rgba(0, 0, 0, 0.9);
          position: fixed;
        "
      >
        <div class="logo-header">
          <a href="https://voyage-lambert.com">
            <img
              src="./assets/Logo_Blanc_Fond Transparent.png"
              alt="logo-voyage-lambert"
            />
          </a>
        </div>

        <b-navbar toggleable="xl" sticky type="dark" class="navbar">
          <b-collapse
            class="collapse"
            id="collapse-1"
            is-nav
            style="color: white"
          >
            <b-navbar-nav class="navbar-menu mx-auto">
              <div class="main-navigation">
                <ul class="menu-principal">
                  <li>
                    <a href="https://www.voyages-lambert.com">Accueil</a>
                  </li>
                  <li>
                    <a
                      href="https://www.voyages-lambert.com/presentation-en-ligne/"
                      >Présentations</a
                    >
                  </li>
                  <li>
                    <a href="https://www.voyages-lambert.com/causeries/"
                      >CONFÉRENCES</a
                    >
                  </li>
                  <li>
                    <a href="https://www.voyages-lambert.com/blogue/">Blogue</a>
                  </li>
                  <li>
                    <a
                      href="https://www.voyages-lambert.com/agence-de-voyages-quebec/qui-sommes-nous/"
                      >L'agence</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.voyages-lambert.com/agence-de-voyages-quebec/qui-sommes-nous/#contact"
                      >Contact</a
                    >
                  </li>

                  <b-nav-item-dropdown right no-caret v-if="user.token">
                    <template #button-content>
                      <b-icon
                        icon="person"
                        class="infoProfil point"
                        scale="1"
                      />{{ user.name + " " + user.lastName }}
                      <b-icon icon="chevron-down" class="point" scale="1" />
                    </template>
                    <b-dropdown-item @click="toMenu">Menu</b-dropdown-item>
                    <b-dropdown-item @click="toClient"
                      >Profils voyageurs</b-dropdown-item
                    >
                    <b-dropdown-item @click="toVoyage"
                      >Mes réservations</b-dropdown-item
                    >
                    <b-dropdown-item @click="toHistorique"
                      >Mon historique</b-dropdown-item
                    >
                    <b-dropdown-item @click="toFavori"
                      >Mes favoris</b-dropdown-item
                    >
                    <b-dropdown-item
                      @click="clickLogout"
                      style="font-weight: bold !important"
                      >Déconnexion</b-dropdown-item
                    >
                  </b-nav-item-dropdown>
                  <li v-else>
                    <router-link to="signin">Connexion</router-link>
                  </li>
                </ul>
              </div>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
        <img
          class="menu-btn svgWhite"
          v-b-toggle.sidebar-navMenu
          src="@/assets/Nav-btn.svg"
        />
        <b-sidebar
          no-header
          id="sidebar-navMenu"
          no-enforce-focus
          bg-variant="transparent"
          right
          shadow
        >
          <template #default="{ hide }">
            <div class="sidebarmenu navbarText">
              <div class="closeIcon" @click="hide">
                <b-icon icon="x" aria-hidden="true" />
              </div>
              <div
                class="side-nav-item"
                v-b-toggle.collapse-CLIENTS
                v-if="user.name !== undefined"
              >
                <div>
                  Espace Client&nbsp;
                  <img
                    data-not-lazy
                    src="./assets/dropdown.svg"
                    class="svgPrimary dropIcon"
                    alt="DropDown Icon"
                  />
                </div>

                <b-collapse id="collapse-CLIENTS" class="mt-2">
                  <router-link to="/" class="side-dropdown-item"
                    >Menu</router-link
                  >
                  <div class="dropdownDivider"></div>
                  <router-link to="client" class="side-dropdown-item"
                    >Profils voyageurs</router-link
                  >
                  <div class="dropdownDivider"></div>
                  <router-link to="triplist" class="side-dropdown-item"
                    >Mes réservations</router-link
                  >
                  <div class="dropdownDivider"></div>
                  <router-link to="historique" class="side-dropdown-item">
                    Mon historique
                  </router-link>
                  <div class="dropdownDivider"></div>
                  <router-link to="favoritelist" class="side-dropdown-item">
                    Mes favoris
                  </router-link>
                  <div class="dropdownDivider"></div>
                  <a @click="clickLogout" class="side-dropdown-item">
                    Déconnexion
                  </a>
                </b-collapse>
              </div>
              <router-link
                v-else
                @click="hide()"
                to="signin"
                class="side-nav-item"
                v-b-toggle.sidebar-navMenu
              >
                Connexion
              </router-link>
              <div class="sidebarDivider"></div>
              <a
                @click="hide()"
                class="side-nav-item"
                v-b-toggle.sidebar-navMenu
                href="https://www.voyages-lambert.com"
              >
                Accueil</a
              >
              <div class="sidebarDivider"></div>
              <a
                @click="hide()"
                class="side-nav-item"
                v-b-toggle.sidebar-navMenu
                href="https://www.voyages-lambert.com/presentation-en-ligne/"
              >
                Présentations</a
              >
              <div class="sidebarDivider"></div>
              <a
                @click="hide()"
                class="side-nav-item"
                v-b-toggle.sidebar-navMenu
                href="https://www.voyages-lambert.com/causeries/"
              >
                CONFÉRENCES
              </a>
              <div class="sidebarDivider"></div>
              <a
                @click="hide()"
                class="side-nav-item"
                v-b-toggle.sidebar-navMenu
                href="https://www.voyages-lambert.com/blogue/"
              >
                Blogue</a
              >
              <div class="sidebarDivider"></div>
              <a
                @click="hide()"
                class="side-nav-item"
                v-b-toggle.sidebar-navMenu
                href="https://www.voyages-lambert.com/agence-de-voyages-quebec/qui-sommes-nous/"
              >
                L'agence</a
              >
              <div class="sidebarDivider"></div>
              <a
                @click="hide()"
                class="side-nav-item"
                v-b-toggle.sidebar-navMenu
                href="https://www.voyages-lambert.com"
              >
                Contact</a
              >
            </div>
          </template>
        </b-sidebar>
      </header>

      <router-view />
    </div>
    <footer>
      © Voyage Lambert - Tous droits réservés 2022 / Site web par Elefen / Mise
      à jour 2022-05-24
    </footer>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "app",
  components: {},
  data() {
    return {
      hauteur: "1px",
      first: true,
    };
  },
  computed: {
    ...mapState({
      alert: (state) => state.alert,
      alertToggle: (state) => state.alert.toggle,
      user: (state) => state.auth.user,
      loggedIn: (state) => state.auth.status.loggedIn,
      clients: (state) => state.client.list,
    }),
  },
  methods: {
    ...mapActions(["postClient", "getClients", "logout", "validate"]),
    clickLogout() {
      this.logout();
    },
    onResize() {
      this.resizeHauteur();
    },
    resizeHauteur() {
      this.hauteur = window.innerHeight - 35 + "px";
    },
    toVoyage() {
      this.$router.push({
        name: "TripList",
      });
    },
    toMenu() {
      this.$router.push({
        name: "Menu",
      });
    },
    toSignin() {
      this.$router.push({
        name: "Signin",
      });
    },
    toClient() {
      this.$router.push({
        name: "Client",
      });
    },
    toHistorique() {
      this.$router.push({
        name: "historique",
      });
    },
    toFavori() {
      this.$router.push({
        name: "favoriteList",
      });
    },
  },
  watch: {
    $route() {
      // clear alert on location change
      this.$store.dispatch("alert/clear");
    },
    alertToggle() {
      this.$bvToast.show("example-toast");
    },
    user() {
      if (this.user.name !== undefined) {
        this.getClients();
      }
    },
    loggedIn() {
      if (!this.loggedIn) {
        this.$router.push("/signin?pagetype=disconnected");
      } else {
        this.getClients();
      }
    },
    clients() {
      if (this.clients.length === 0) {
        if (this.first === true) {
          this.postClient({
            param: {
              fields: {
                Nom: this.user.lastName,
                Prenom: this.user.name,
                Validation_isUser: 1,
                Courriel: this.user.email,
              },
            },
          });
        }
        this.first = false;
      }
    },
  },
  mounted() {
    this.resizeHauteur();
    if (this.loggedIn) {
      this.getClients();
    }
    if (this.$route.query.pagetype === "disconnected") {
      this.headerPosition = "initial";
    } else if (this.$route.query.pagetype === "connected") {
      this.headerPosition = "fixed";
    }
  },
  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style>
.b-toaster {
  z-index: 10000 !important;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}
.svgWhite {
  filter: invert(100%) sepia(0%) saturate(7475%) hue-rotate(197deg)
    brightness(105%) contrast(109%);
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}
.navbar {
  display: unset;
}
.nav-color {
  background-color: #242629 !important;
}
.logo {
  width: 130px;
  height: 60px;
}
.center {
  text-align: center;
}

.inputform {
  width: 100%;
  height: 38px;
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: white;
  text-align: center;
  padding: 20px;
}
.soustitre {
  background-color: #242629 !important;
  text-align: center;
  padding: 20px;
  color: white;
}

.closeIcon {
  position: absolute;
  right: 20px;
  top: 10px;
  font-size: 32px;
  cursor: pointer;
  color: #ffffff;
  padding-right: 10px !important;
}

.containerBackground {
  background-color: #313439;
  background-repeat: no-repeat !important;
  background-position: center;
  background-attachment: fixed;
}

.navbar-dark .navbar-toggler {
  color: #ffffff !important;
  border-color: transparent !important;
}
.navbar-dark .navbar-nav .nav-link {
  color: #ffffff !important;
}
.navbar-dark .navbar-nav .nav-link:hover {
  text-decoration: underline !important;
}
.point {
  font-size: 20px;
  padding: 0 2.5px;
  margin-bottom: 3px;
  font-weight: bolder;
}
.dropdown {
  position: relative;
  display: inline-block;
}
.sidebarmenu {
  background-color: rgba(25, 25, 25, 0.98) !important;
  height: 100vh;
  padding: 30px;
  max-height: none;
  text-align: left;
  backdrop-filter: blur(0px) !important;
}
.showDropdown {
  display: block;
  animation: growDown 300ms ease-in-out forwards;
  transform-origin: top center;
}
.menu-btn {
  display: none;
}
.side-nav-item {
  margin-top: 20px;
  margin-bottom: 20px;
  cursor: pointer;
  text-transform: uppercase;
  text-decoration: inherit;
  align-items: left;
  display: flex;
  flex-direction: column;
  color: #ffffff !important;
  outline: none !important;
}

.side-dropdown-item {
  /* margin-left: 30px; */
  margin-top: 10px;
  padding: 5px 20px;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  text-decoration: inherit;
  text-transform: none;
  color: inherit;
  color: #ffffff;
}

.side-dropdown-item:hover {
  color: #ffffff;
  transition: ease 0.3s;
}
.sidebarDivider {
  height: 1px;
  margin-top: 0;
  background-color: rgba(255, 255, 255, 0.2);
}

.infoProfil {
  margin-left: 50px !important;
}

@media (max-width: 1200px) {
  .navbar {
    display: none !important;
  }
  .profilName {
    display: none;
  }
  .navbar-dark .navbar-nav .nav-link {
    padding: 20px 15px !important;
  }

  .menu-btn {
    cursor: pointer;
    display: flex !important;
    height: 30px;
    position: absolute;
    right: 82px;
    width: 40px;
  }
}
</style>
